import Box from '@mui/material/Box';
import { BackIcon } from 'assets/icons';
import ErrorImg from 'assets/images/404.webp';
import { PrimaryBtn } from 'components/UI/Buttons';
import { useNavigate } from 'react-router-dom';
import { NAVY, RADIUS_COIN, YELLOW } from 'styles/tokens';

const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: '100%',
        mt: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <img src={ErrorImg} alt="Error" style={{ width: 'min(480px, 98%)', borderRadius: '16px' }} />
      <PrimaryBtn
        onClick={() => navigate('/clients')}
        sx={{
          mt: 4,
          backgroundColor: YELLOW,
          color: NAVY,
          borderRadius: RADIUS_COIN,
          fontFamily: 'Jost, sans-serif',
          fontWeight: 600,
          px: 4,
          '&:hover': { backgroundColor: '#EAC300' },
        }}
        startIcon={<BackIcon />}
        variant="contained"
      >
        Volver
      </PrimaryBtn>
    </Box>
  );
};

export default ErrorPage;
